export default "__VITE_ASSET__DwHHToq7__"